import { render, staticRenderFns } from "./detailCheck.vue?vue&type=template&id=cf6fb4de"
import script from "./detailCheck.vue?vue&type=script&lang=js"
export * from "./detailCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports